import React, {FC, PropsWithChildren} from 'react';
import {Link} from 'react-router-dom';

import {READ_BUNDLE} from '../../components/updatejobs/consts';
import hasAuthority from './hasAuthority';
import {BUNDLE_MANAGEMENT_ROUTE_ABSOLUTE_PATH} from '../../modules/common/consts';

type Props = {
	bundleId: string;
};

const BundleLink: FC<PropsWithChildren<Props>> = ({bundleId, children}) => {
	const canSeeBundles = hasAuthority(READ_BUNDLE);
	return bundleId && canSeeBundles && children ? (
		<Link to={`${BUNDLE_MANAGEMENT_ROUTE_ABSOLUTE_PATH}/bundles?bundleId=${bundleId}`}>{children}</Link>
	) : (
		<>{children}</>
	);
};

export default BundleLink;
